import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

const submitRegistrationService = async (baseURL, requestBody) => {
  try {
    const submitRegistrationResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.submitRegistration}`,
      JSON.stringify(requestBody)
    );
    if (
      submitRegistrationResponse?.status === 200 &&
      submitRegistrationResponse.data
    ) {
      return submitRegistrationResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export default submitRegistrationService;
